import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'telio-faq-manage',
  templateUrl: './faq-manage.component.html',
  styleUrls: ['./faq-manage.component.scss']
})
export class FaqManageComponent implements OnInit {
  
  options: UntypedFormGroup;
  value: any;

  constructor(fb: UntypedFormBuilder, readonly translate: TranslateService) { 
    this.options = fb.group({
      display: new UntypedFormControl('both'),
      question: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
      answer: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
      enable: new UntypedFormControl('active')
    });
  }

  ngOnInit(): void {
    if(this.options.value){
      this.value = this.options.value
      this.value.display ? this.options.controls['display'].setValue(this.value.display.toLowerCase()) : this.options.controls['display'].setValue('Both');
      this.value.question ? this.options.controls['question'].setValue(this.value.question) : this.options.controls['question'].setValue('');
      this.value.answer ? this.options.controls['answer'].setValue(this.value.answer) : this.options.controls['answer'].setValue('');
      this.value.enable ? this.options.controls['enable'].setValue('active') : this.options.controls['enable'].setValue('inactive');
      this.options.controls['display'].updateValueAndValidity();
      this.options.controls['question'].updateValueAndValidity();
      this.options.controls['answer'].updateValueAndValidity();
      this.options.controls['enable'].updateValueAndValidity();
    }
  }
}
